export default class Equalizer {
    static equalizeItems(items) {
        const equalizeItemsList = items;
        let maxHeight = 0;

        for (let i = 0; i < equalizeItemsList.length; i += 1) {
            const ele = equalizeItemsList[i];
            ele.style.minHeight = 0;
            const eleHeight = ele.offsetHeight;
            maxHeight = (eleHeight > maxHeight ? eleHeight : maxHeight);
        }

        for (let i = 0; i < equalizeItemsList.length; i += 1) {
            equalizeItemsList[i].style.minHeight = `${maxHeight}px`;
        }
    }
}
